/**
 * password validation response: {
        "level": (int) 0/1/2, //0 --> weak, 1 --> medium, 2 --> strong
        "valid": (bool) false/true
        }
 */
export enum PasswordValidationLevel {
    WEAK = 0,
    MEDIUM = 1,
    STRONG = 2
}
export interface PasswordValidationResponse {
    level: PasswordValidationLevel;
    valid: boolean;
}

export interface PasswordValidationPayload {
    password: string;
    checksum?: number;
}
